import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useThemeProps, Pagination } from '@mui/material';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _templateObject;

var _excluded = ["value", "onChange", "pageSize", "totalItems", "className", "sx", "variant"];
var componentRoot = createComponentSlot({
  name: "CinPageNumber",
  slot: "Root"
});

var PageNumberBase = function PageNumberBase(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize,
      totalItems = _ref.totalItems,
      className = _ref.className;
      _ref.sx;
      var variant = _ref.variant,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var totalPages = totalItems > 0 ? Math.ceil(totalItems / pageSize) : 0; // fallback to text if PageNumber variant is not supported by Pagination

  var paginationVariant = variant === "outlined" ? variant : "text";
  return /*#__PURE__*/React.createElement(Pagination, _extends({}, otherProps, {
    page: value,
    count: totalPages,
    onChange: function onChange(e, page) {
      return _onChange && _onChange(page);
    },
    className: classnames(componentRoot.className, className),
    variant: paginationVariant
  }));
};

PageNumberBase.propTypes = {
  value: propTypes.number.isRequired,
  onChange: propTypes.func,
  pageSize: propTypes.number,
  totalItems: propTypes.number.isRequired,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var PageNumberRoot = styled(PageNumberBase, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
PageNumberRoot.defaultProps = {
  variant: "text"
};
/**
 * A set of navigation buttons for changing the page number
 */

var PageNumber = function PageNumber(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(PageNumberRoot, rootProps);
};

var PageNumber$1 = PageNumber;

export { PageNumber$1 as default };
